import { render, staticRenderFns } from "./ContractFormInfo.vue?vue&type=template&id=867b8ac6&"
import script from "./ContractFormInfo.vue?vue&type=script&lang=js&"
export * from "./ContractFormInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports